<template>
	<div style="min-width: 1320px;margin: 0 auto;overflow-x: auto;">
		<div class="header">
			<common-head  @showLogin='openLogin'></common-head>
		</div>
		<div style="height: 96px;"></div>
		<div style="min-height: calc(100vh - 96px - 81px);">
			<router-view></router-view>
		</div>
		<div class="footer">
			  <common-footer></common-footer>
		</div>
		<login-popup  ref='lpopup'></login-popup>
	</div>
</template>

<script>
	import CommonHead from "../components/CommonHead.vue"
	import CommonFooter from "../components/CommonFooter.vue"
	import LoginPopup from '@/components/LoginPopup';
	import { userInfoApi } from '@/api/user/user';
	export default {
		components: {
			CommonHead,CommonFooter,LoginPopup
		},
		data() {
			return {
				userInfo:{},
			}
		},
		async created() {
			await userInfoApi().then(res=>{
				console.log(res);
				this.userInfo = res.data
				const { nickName, phone, userId, avatar } = res.data || {};
				const info = {nickName,phone,userId,avatar}
				localStorage.setItem('userInfo',JSON.stringify(info));
				this.$store.state.isLoggedIn = info.userId
				this.$store.state.userInfo = info
			})
		},
		methods:{
			openLogin(){
				this.$refs.lpopup.loginWay1 = true
			},
		},
	}
</script>

<style>
	body{
		background: #F7F8FA;
		overflow-y: scroll;
	}
	body::-webkit-scrollbar {
	/* background: var(--scrollbar-background); */
}
	.header{
		background-color: #fff;
		color: #333;
		text-align: center;
		padding: 0;
		height: 96px;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 999;
		border-bottom: 1px solid #F7F8FA;
	}
	.footer{
		background-color: #fff;
		color: #333;
		text-align: center;
		padding: 0;
		/* height: 300px; */
		height: 81px;
		position: relative;
	}
	.el-container{
		min-width: 1200px;
		margin: 0 auto;
		min-height: 100vh;
	}
	.el-header,.el-footer {
		background-color: #fff;
		color: #333;
		text-align: center;
		padding: 0;
		height: 96px;
	}
	
	.el-aside {
		background-color: #D3DCE6;
		color: #333;
		text-align: center;
		/* line-height: 200px; */
	}
</style>